import { useCallback } from 'react';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';
import DisplaiAcademyThumbnail from '../LibraryPage/v2/components/EmptyLibrary/DisplaiAcademyThumbnail.png';
import ImagesThumbnail from '../LibraryPage/v2/components/EmptyLibrary/ImagesThumbnail.svg';
import InstagramThumbnail from '../LibraryPage/v2/components/EmptyLibrary/InstagramThumbnail.svg';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as presentationPageActions from '../PresentationPage/actions';
import * as paths from '../../routes/paths';
import PresentationCard from '../LibraryPage/v2/components/EmptyLibrary/PresentationCard';

export interface EmptyLibraryPros {
  pageUrl: string;
  onCreate: () => void;
}

const INSTAGRAM_APP_ID = 'a0853ff6-f790-4743-80fe-246e9d29eba1';
const IMAGES_APP_ID = '2058e0f9-8d7e-4ca0-946d-cb93e3f305b2';

const AddContentPageEmptyLibrary = ({
  pageUrl,
  onCreate,
}: EmptyLibraryPros) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const newPresentation = useCallback(
    (applicationId: string) => {
      dispatch(presentationPageActions.clearUnsavedPresentation(applicationId));

      history.push(
        paths.newPresentation({
          applicationId,
          backTo: pageUrl,
          backToLabel: 'Back to Library',
          saveTo: pageUrl,
        }),
      );
    },
    [dispatch, history, pageUrl],
  );

  return (
    <div className="flex flex-1 flex-col items-center text-black">
      <Text className="text-xl font-bold my-2">
        It's a little quite in here
      </Text>
      <Text variant="caption">
        You can add folders, apps and more! Try some below:
      </Text>
      <div className="flex my-7 flex-wrap gap-6">
        <PresentationCard
          img={DisplaiAcademyThumbnail}
          label="Learn more about Libraries"
          onClick={() =>
            window.open('https://www.youtube.com/watch?v=iBZLRufqTAA', '_blank')
          }
        />
        <PresentationCard
          img={ImagesThumbnail}
          label="Create Pictures presentation"
          onClick={() => newPresentation(IMAGES_APP_ID)}
        />
        <PresentationCard
          img={InstagramThumbnail}
          label="Create Instagram presentation"
          onClick={() => newPresentation(INSTAGRAM_APP_ID)}
        />
      </div>
      <Button onPress={() => onCreate()}>Create a Presentation</Button>
    </div>
  );
};

export default AddContentPageEmptyLibrary;
